module.exports = __webpack_public_path__ + "img/straight-rail-vertical-stone-path.5b2c2e6b.png";